<template>
    <!-- <div class="main-menu">
        <img :src="bgImg" />
        <div class="hotspots" v-show="currentMenu == null">
            <hotspot v-for="area in areas" :key="area.handle" :area="area" @click.native="currentMenu = area.handle"></hotspot>
        </div>
        <transition name="fade" v-for="area in areas" :key="area.handle">
            <sub-menu :area="area" v-if="currentMenu == area.handle" @close-sub-menu="currentMenu = null"></sub-menu>
        </transition>
    </div> -->

    <div class="main-menu">    
        <img :src="bgImg">    
        <div class="hotspots" v-show="currentMenu == null">       
            <hotspot v-for="area in areas" :key=area.handle :area="area" @click.native="currentMenu = area.handle"></hotspot>     
        </div>    
        
    <transition name="fade" v-for="area in areas" :key="area.handle">        
        <sub-menu :area="area" v-if="currentMenu == area.handle" @close-sub-menu="currentMenu = null"></sub-menu>    
        </transition>
    </div>
</template>
<script>
import $ from 'jquery';
window.$ = require('jquery');
    import areas from '../data-src/MainAreas.json';
    import Hotspot from './Hotspot-item.vue';
    import SubMenu from './SubMenu.vue';

    export default {
        data() {
            return {
                areas,
                bgImg : "../interactive_truck_display_2024_updates/dist/images/2022/TruckRearWheelFirstFrame.png",
                currentMenu : null
            }
        },
        components : {
            Hotspot,
            SubMenu
        },
        mounted() {
            let hotspots = this.$el.querySelectorAll('.hotspot'), interval = 1;

            hotspots.forEach(hotspot => {
                setTimeout(function() {
                    $(hotspot).addClass('animated');
                },interval);
                interval += 2000;
            });

            this.$root.$on('touch-here-mode', function(e) {
                if( e ) {
                    let rand = (Math.floor((Math.random() * hotspots.length) + 1)-1);
                    $(hotspots[rand]).addClass('touchable');

                    setTimeout(function() {
                        $(hotspots[rand]).removeClass('touchable');
                    }, 3000)
                } else {
                    $(hotspots).removeClass('touchable');
                }
            });

        }
    }
</script>